import React, { Fragment, useState, useCallback } from 'react';

import { 
    Button, 
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';

import LogsList from '../LogsList/index';

export default function GroupTitle(props) {
    const { 
        heading, 
        icon, 
        subheading, 
        // organization, 
        role,
        showLogs
    } = props;

    const [modalCallLogs, setModalCallLogs] = useState(false);
    const toggleModalCallLogs = useCallback(() => {
        setModalCallLogs(!modalCallLogs);
    }, [setModalCallLogs, modalCallLogs]);

    return (
        <div className="app-page-title">
            <div className="page-title-wrapper">
                <div className="page-title-heading">
                    <div className="page-title-icon rounded-circle">
                        <i className={icon} />
                    </div>
                    <div>
                        {heading}
                        <div className="page-title-subheading">
                            {subheading}
                        </div>
                        {/*<div className="page-title-subheading">
                            {organization}
                        </div>
                        */}
                    </div>
                </div>
                <div className="page-title-actions">
                    {showLogs && showLogs === true && (
                        <Fragment>
                            <Button
                                className="btn-pill mr-3"
                                color="secondary"
                                id="calllogss"
                                onClick={() => {
                                    toggleModalCallLogs();
                                }}
                            >
                                Call Logs
                            </Button>
                            <UncontrolledTooltip
                                placement="bottom"
                                target={'calllogss'}
                            >
                                View My Call Logs
                            </UncontrolledTooltip>

                            <Modal isOpen={modalCallLogs} toggle={toggleModalCallLogs}>
                                <ModalHeader toggle={toggleModalCallLogs}>
                                    Call Logs
                                </ModalHeader>
                                <ModalBody>
                                    <LogsList
                                        role={role}
                                    />
                                </ModalBody>
                            </Modal>
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    );
}
